module.exports = __webpack_public_path__ + "img/alert.a9c91baf.svg";